import React from 'react'
// libs
import moment from 'moment'
import { useSelector } from 'react-redux'
// components
import { Avatar } from 'components/UI'
import { TableRow } from '@mui/material'
// views
import { TableCell } from 'themes/views/tables'
// types
import { IOption } from 'components/FormElements/Select'
import { FieldType, IField, ILog } from 'types/graphql'
// store
import { responseTypesSelector } from 'store/reducers/riskTemplates'
// views
import { Link, ColoredValue, OwnedByInfo } from './views'
// utils
import { getOwnedBy } from 'utils/index'
import { getFieldValue } from './utils'

interface Props {
  data: ILog
  field: IField
  options: IOption[]
}

const Row: React.FC<Props> = ({ data, field, options }) => {
  const { user, createdAt, metadata } = data

  const responseTypeSets = useSelector(responseTypesSelector)

  const value = metadata.value
  const ownedBy = getOwnedBy(null, user)

  const responseTypeOptions = responseTypeSets.find((item) => item.id == field.responseTypeId)?.options || []

  const fieldValue = getFieldValue(value, {
    ...field,
    options: field.fieldType === FieldType.Lookup ? options : field.responseType ? responseTypeOptions : field.options
  })

  return (
    <TableRow hover>
      <TableCell size={40}>
        {field.fieldType === FieldType.DocumentOrLink ? (
          <Link href={value.url} target='_blank'>
            {value.title || value.type.toLowerCase()}
          </Link>
        ) : field.fieldType === FieldType.RiskMatrix ? (
          <ColoredValue $color={fieldValue?.color}>{fieldValue.label}</ColoredValue>
        ) : field.fieldType === FieldType.Address ? (
          fieldValue.value?.address
        ) : field.responseType ? (
          <ColoredValue $color={fieldValue?.color}>{fieldValue.label}</ColoredValue>
        ) : (
          fieldValue
        )}
      </TableCell>
      <TableCell size={30}>
        Skefto UI
        <OwnedByInfo>
          by
          <Avatar user={user} />
          {ownedBy}
        </OwnedByInfo>
      </TableCell>
      <TableCell size={30}>{moment(createdAt).format('DD/MM/YYYY [at] h:mm A Z')}</TableCell>
    </TableRow>
  )
}

export default Row
